// We load the default CSS synchronously so that webpack will use the entry name
// (main) for the filename (main.css). We need a deterministic name because we
// reference this CSS file in the `index.pug` template.
import '../less/themes/public.default.less';

// This module serves as an asynchronous barrier for our local and remote
// applications. This is a required step in order for Module Federation to work
// correctly.
import('./ApplicationPublic');
